<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <a ref="target" id="target"></a>
    <div class="content-title content-mb-14">
      {{ getStepNumber() }}. Цели и показатели проекта
    </div>
    <uf_result_natural></uf_result_natural>
    <template
      v-if="
        $parent.getProgramCode() === 'working' ||
          $parent.getProgramCode() === 'working_rfrp'
      "
    >
      <p class="content-s-2-label">
        <label>Базовый год</label>
        <!--   начало блока подсказки   -->
        <span
          v-if="
            project.UF_HELP &&
              project.UF_HELP.FIELDS &&
              project.UF_HELP.FIELDS.STEP2 &&
              project.UF_HELP.FIELDS.STEP2.UF_BASE_YEAR
          "
          class="h-t-status-info info-holder-container"
        >
          <span
            class="info-holder-icon"
            style="margin-left: 100px; margin-top: -22px;"
          ></span>
          <span
            class="info-holder-content info-holder-content_link"
            style="left: 100%;"
          >
            <span class="info-holder-content__text">
              {{ project.UF_HELP.FIELDS.STEP2.UF_BASE_YEAR }}
            </span>
          </span>
        </span>
        <!--   конец блока подсказки   -->
      </p>
      <uf_base_year></uf_base_year>
    </template>
    <target_years></target_years>

    <div
      class="row myrow content-mb-42"
      v-if="
        ($parent.getProgramCode() === 'cifrovizaciya' ||
          $parent.getProgramCode() === 'epidemiological_control') &&
          project.UF_INDICATOR_VERSION === 1
      "
    >
      <div class="col-xs-12 mycol">
        <textarea
          :disabled="$parent.$parent.projectDisabled"
          v-model="project.UF_SALE"
          class="i-main-style t-dop-style i-wid-50"
          placeholder="Укажите планируемые объемы продаж/спроса, наличие инструментов реализации продукции проекта, перечень договоренностей по реализации продукции проекта: соглашения, предварительные соглашения, переговоры и т.п."
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import { AUTH_URL } from "@/common/config";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Uf_base_year from "@/components/project/form/partial/uf_base_year.vue";

export default {
  name: "step2",
  props: ["step", "project"],
  components: {
    Uf_base_year,
    Target_years,
    Uf_result_natural
  },
  data() {
    return {
      selectedTags: [],
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      countriesLoaded: false
    };
  },

  async created() {
    this.siteUrl = AUTH_URL;
    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "product_plan_import",
      "start_pokazatel",
      "tree/vid_prom_products",
      "sp_list_actual_technology",
      "sp_ndt",
      "sp_type_productions"
    ]);

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {
        if (this.$parent.getProgramCode() === "cifrovizaciya") {
          if (
            this.project.UF_STAVKA_PR_YEAR === "" ||
            this.project.UF_STAVKA_PR_YEAR === 0
          ) {
            this.project.UF_STAVKA_PR_YEAR = 5;
          }
        }
      }, this);
  },

  computed: {
    ...mapGetters(["directory"])
  },

  methods: {
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        return el.ID === id;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    getStepNumber() {
      const code = this.$parent.getProgramCode();
      let step = 20;
      switch (code) {
        case "archive":
          step = 18;
          break;
        case "auto_components":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1 && this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM === 1) {
            step = 25;
          }else if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1 || this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM === 1) {
            step = 24;
          } else {
            if (this.project.UF_SETTING.IS_HIDE_NDT == 1) {
              if (this.project.UF_SETTING.IS_VIEW_HIGH_TECH == 1) {
                step = 23;
              } else {
                step = 22;
              }
            } else {
              step = 23;
            }
          }
          break;
        case "cifrovizaciya":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            step = 24;
          } else {
            step = 23;
          }
          break;
        case "complectyushie":
          if (this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1 &&
              this.project.IS_SHOW_TYPE_LOAN == 1) {
            step = 25;
          } else if (this.project.IS_SHOW_TYPE_LOAN == 1) {
            step = 24;
          }else if (this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1) {
            step = 23;
          } else {
            step = 22;
          }
          break;
        case "complectyushie_rfrp":
          if (this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1 &&
            this.project.IS_SHOW_TYPE_LOAN == 1) {
            step = 24;
          }else if (this.project.IS_SHOW_TYPE_LOAN == 1) {
            step = 23;
          }else if (this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1) {
            step = 22;
          } else {
            step = 21;
          }
          break;
        case "component_and_resource_base":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (this.$parent.isViewComplectyushieProduct) {
              step = 18;
            } else {
              step = 17;
            }
          } else {
            if (this.$parent.isViewComplectyushieProduct) {
              step = 17;
            } else {
              step = 16;
            }
          }
          break;
        case "epidemiological_control":
          step = 13;
          break;
        case "evolution":
          if (
            this.project.UF_VERSION < 3 ||
            this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1
          ) {
            if (
              this.project.UF_SETTING
                .IS_VIEW_CRITICAL_COMPONENT_MVK_EVOLUTION == 1 ||
              this.project.UF_SETTING.IS_VIEW_GRANT_BEEN_DEVELOPMENT == 1
            ) {
              if (this.project.UF_DIRECTION_FINANCING_ID > 0) {
                if (
                  this.project.UF_SETTING
                    .IS_VIEW_REESTR_USING_RM == 1
                ) {
                  step = 25;
                }else if (
                  this.project.UF_SETTING
                    .IS_VIEW_PROIORITY_PRODUCTS_FORMED_MVK == 1
                ) {
                  step = 24;
                } else {
                  step = 23;
                }
              } else {
                step = 22;
              }
            } else if (this.project.UF_DIRECTION_FINANCING_ID > 0) {
              step = 22;
            } else {
              step = 21;
            }
          } else {
            step = 20;
          }
          break;
        case "forestry_projects_rfrp":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            step = 19;
          } else {
            step = 18;
          }
          break;
        case "improving_ecology":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (this.project.UF_SETTING.IS_HIDE_NDT == 1) {
              step = 19;
            } else {
              step = 20;
            }
          } else {
            step = 19;
          }
          break;
        case "lekarstva":
          step = 17;
          break;
        case "lizing":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1 && this.project.UF_SETTING.IS_VIEW_LIST_NDT === 1) {
            step = 22;
          }if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1 && this.project.UF_SETTING.IS_VIEW_LIST_NDT === 0) {
            step = 21;
          } else if (this.project.UF_INDICATOR_VERSION === 1 &&  this.project.UF_SETTING.IS_VIEW_LIST_NDT === 1){
            step = 22;
          } else if (this.project.UF_INDICATOR_VERSION > 1 &&  this.project.UF_SETTING.IS_VIEW_LIST_NDT === 0){
            step = 21;
          }else if (this.$parent.isViewIndustrial && this.project.UF_SETTING.IS_VIEW_LIST_NDT === 1) {
            step = 21;
          } else if (this.$parent.isViewIndustrial && this.project.UF_SETTING.IS_VIEW_LIST_NDT === 0) {
            step = 20;
          } else {
            step = 19;
          }
          break;
        case "priority_program":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (this.project.UF_PRIORITY_PROJECT_VERSION === 3) {
              step = 28;
            } else {
              step = 29;
            }
          } else {
            if (this.project.UF_PRIORITY_PROJECT_VERSION === 3) {
              step = 27;
            } else {
              step = 28;
            }
          }
          break;
        case "providing_mobilization_needs":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (this.project.UF_DIRECTION_FINANCING_ID > 0) {
              if (this.project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES === 1) {
                step = 14;
              } else {
                step = 15;
              }
            } else {
              step = 14;
            }
          } else {
            step = 13;
          }
          break;
        case "regfond":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (this.project.UF_DIRECTION_FINANCING_ID > 0) {
              if (
                this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM ==
                1
              ) {
                step = 24;
              }else if (
                this.project.UF_SETTING.IS_VIEW_PROIORITY_PRODUCTS_FORMED_MVK ==
                1
              ) {
                step = 23;
              } else {
                step = 22;
              }
            } else if (
              this.project.UF_SETTING
                .IS_VIEW_CRITICAL_COMPONENT_MVK_EVOLUTION == 1
            ) {
              step = 21;
            } else {
              step = 20;
            }
          } else {
            if (this.project.UF_VERSION < 3) {
              step = 20;
            } else {
              step = 19;
            }
          }
          break;
        case "transport_engineering":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (!this.$parent.hideMVK) {
              step = 20;
            } else {
              step = 10;
            }
          } else {
            if (!this.$parent.hideMVK) {
              step = 19;
            } else {
              step = 18;
            }
          }
          break;
        case "working_rfrp":
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (this.project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1) {
              if (this.project.UF_SETTING.IS_VIEW_HIGH_TECH == 1 && this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1) {
                step = 24;
              }else if (this.project.UF_SETTING.IS_VIEW_HIGH_TECH == 1) {
                step = 23;
              } else {
                step = 22;
              }
            } else {
              step = 24;
            }
          } else {
            step = 22;
          }
          break;
        default:
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS === 1) {
            if (
              this.$parent.getProgramCode() === "stankostroi" ||
              this.$parent.getProgramCode() === "konversia"
            ) {
              step = 21;
              break;
            }
            if (this.$parent.getProgramCode() === "working") {
              if (this.project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1) {
                if (this.project.UF_SETTING.IS_VIEW_HIGH_TECH == 1 && this.project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1) {
                  step = 25;
                }else if (this.project.UF_SETTING.IS_VIEW_HIGH_TECH == 1) {
                  step = 24;
                } else {
                  step = 23;
                }
              } else {
                step = 25;
              }
              break;
            }
            step = 21;
            break;
          } else {
            if (
              this.$parent.getProgramCode() === "konversia" &&
              this.project.UF_VERSION < 3
            ) {
              step = 21;
              break;
            }
            if (
              this.$parent.getProgramCode() === "stankostroi" ||
              this.$parent.getProgramCode() === "konversia"
            ) {
              step = 20;
              break;
            }
            if (this.$parent.getProgramCode() === "working") {
              step = 22;
              break;
            }
            step = 19;
            break;
          }
      }
      return step;
    }
  }
};
</script>

<style scoped></style>
